import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { CButton, CFormCheck, CFormLabel, CFormTextarea, CModal, CModalBody, CModalHeader, CModalTitle } from '@coreui/react';
import { Plus } from 'lucide-react';
import Select from 'react-select';
import Accordions from '../../components/shared/Accordians';
import QuestionDropdownBuilder from './QuestionDropdownBuilder'; // Import QuestionDropdownBuilder
import { motion } from 'framer-motion'
import ModalFormBuilder from './ModalFormBuilder';
import QuestionTextInputFormBuilder from './QuestionTextInputFormBuilder';
import ModalFormBuilderNested from './ModalFormBuilderNested';
import OptionConfigurationModal from './OptionConfigurationModal';
import { ChevronDown, ChevronsUpDown, Pencil, Signature, X } from 'lucide-react'

const resizeOptionName = (field) => {
  field.style.height = 'auto';
  const styles = window.getComputedStyle(field);
  const borderHeight = parseFloat(styles.borderTopWidth) + parseFloat(styles.borderBottomWidth);
  field.style.height = `${field.scrollHeight + borderHeight}px`;
};

const OptionNameField = ({ value, onChange }) => {
  const fieldRef = useRef(null);

  useLayoutEffect(() => {
    resizeOptionName(fieldRef.current);
  }, [value]);

  useEffect(() => {
    const field = fieldRef.current;
    let previousWidth = field.getBoundingClientRect().width;
    const observer = new ResizeObserver(() => {
      const width = field.getBoundingClientRect().width;
      if (width !== previousWidth) {
        previousWidth = width;
        resizeOptionName(field);
      }
    });
    observer.observe(field);
    return () => observer.disconnect();
  }, []);

  return (
    <CFormTextarea
      ref={fieldRef}
      name="label"
      aria-label="Option name"
      rows={1}
      value={value}
      onChange={onChange}
      onClick={(event) => event.stopPropagation()}
      style={{ width: '100%', minWidth: 0, boxSizing: 'border-box', resize: 'none', overflow: 'hidden', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', wordBreak: 'break-word' }}
    />
  );
};

const QuestionDropdownOptions = ({
  dropdownInput,
  setDropdownInput,
  handleAddOptions,
  handleChangeOption,
  fillYesNo,
  setFillYesNo,
  labList,
  medicationData,
  imagingData,
  diagnosiss,
  openQuestionModal,
  styling,
  diagnosisForNested,
  currentTextInputs,
  setCurrentTextInputs,
  addQuestions
}) => {


  const [isBuilderVisible, setIsBuilderVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [configurationTarget, setConfigurationTarget] = useState(null);
  const configurationOption = dropdownInput?.options?.find((option) =>
    configurationTarget && (configurationTarget.id != null
      ? option.id === configurationTarget.id
      : option === configurationTarget.option)
  );
  const addQuestiontoAllOptions = useRef({})
  const [optionsList, setOptionsList] = useState([]);
  const [addQuestionModal, setAddQuestionModal] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isModalOpen, setIsOpenModal] = useState(false)

  const [questionType, setQuestionType] = useState(null);

  const resetInputState = () => {
    setQuestionType('input');

  };

  const resetDropdownState = () => {
    setQuestionType('dropdown');

  };

  useEffect(()=>{
    console.log("In options in use Effect")
    console.log(dropdownInput)

  },[])
  const toggleOptionSelection = (index) => {
    setSelectedOptions((prevSelected) =>
      prevSelected.includes(index)
        ? prevSelected.filter((i) => i !== index) // Remove if already selected
        : [...prevSelected, index] // Add if not selected
    );
  };

  const handleSaveNewQuestion = (newQuestion) => {
    console.log("Saving the new question");
    const updatedOptions = [...dropdownInput.options];
  
    if (addQuestiontoAllOptions.current) {
      console.log("Add question all options current");
      if (Array.isArray(selectedOptions) && selectedOptions.length > 0) {
        selectedOptions.forEach((index) => {
          console.log("In each question");
          if (index !== null) {
            const linkedQuestion = updatedOptions[index].linkedQuestion;
            updatedOptions[index] = {
              ...updatedOptions[index],
              linkedQuestion: Array.isArray(linkedQuestion)
                ? [...linkedQuestion, newQuestion]
                : linkedQuestion
                ? [linkedQuestion, newQuestion]
                : [newQuestion],
            };
          }
        });
      }
      setIsBuilderVisible(false);
      setQuestionType(false);
    } else {
      // Add the newQuestion as linkedQuestion for the selected option
      console.log("Add question is in else...", newQuestion);
      if (selectedOption && selectedOption.index !== null) {
        console.log("Selected Option", selectedOption);
        const linkedQuestion = updatedOptions[selectedOption.index].linkedQuestion;
        updatedOptions[selectedOption.index] = {
          ...updatedOptions[selectedOption.index],
          linkedQuestion: Array.isArray(linkedQuestion)
            ? [...linkedQuestion, newQuestion]
            : linkedQuestion
            ? [linkedQuestion, newQuestion]
            : [newQuestion],
        };
      }
      console.log("Updated Options", updatedOptions);
      setIsBuilderVisible(false);
      setQuestionType(false);
    }
  
    // Update the state with the modified options
    setDropdownInput((prev) => ({
      ...prev,
      options: updatedOptions,
    }));
  
    // Reset states
    setIsBuilderVisible(false);
    setSelectedOption(null);
    setQuestionType(false);
    setSelectedOptions([]); // Clear selected options
    addQuestiontoAllOptions.current = false;
  };
  

  const handleAddQuestion = () => {
    setOptionsList(
      dropdownInput.options.map((option, index) => ({
        label: option.label || `Option ${index + 1}`,
        index,
      }))
    );
    setAddQuestionModal(true);

  }

  const handleSelectedOption = () => {
    setAddQuestionModal(false)
    setIsBuilderVisible(true);
    addQuestiontoAllOptions.current = true

  };

  const handleBuilderClose = () => {
    setIsBuilderVisible(false);
    setSelectedOption(null);
  };
  // Handler for Fill Yes/No/Unknown Checkbox
  const handleFillYesNoUnknown = (checked) => {
    console.log("handleFillYesNoUnknown", checked)
    if (checked) {

      const predefinedOptions = [
        {
          id: Math.floor(Math.random() * 1000000), label: "Yes", value: "yes", remark: "", showInAssessment: false, answerText: "", attachOrders: false, suggestDiagnosis: false, diagnosis: null, orders: null, providerInstruction: null, linkedQuestion: null
        },
        {
          id: Math.floor(Math.random() * 1000000), label: "No", value: "no", remark: "", showInAssessment: false, answerText: "", attachOrders: false, suggestDiagnosis: false, diagnosis: null, orders: null, providerInstruction: null, linkedQuestion: null
        },
        {
          id: Math.floor(Math.random() * 1000000), label: "Unknown", value: "unknown", remark: "", showInAssessment: false, answerText: "", attachOrders: false, suggestDiagnosis: false, diagnosis: null, orders: null, providerInstruction: null, linkedQuestion: null
        }

      ];
      setDropdownInput((prev) => ({
        ...prev,
        options: predefinedOptions,
      }));
    } else {

      setDropdownInput((prev) => ({
        ...prev,
        options: [],
      }));
    }
    setFillYesNo(checked);
  };

  const linkQuestionCallback = (optionName, optionIndex) => {
    addQuestiontoAllOptions.current = false

    setSelectedOption({ name: optionName, index: optionIndex });
    setIsBuilderVisible(true);
  };

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("draggedIndex", index);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();

    const draggedIndex = parseInt(e.dataTransfer.getData("draggedIndex"), 10);
    if (draggedIndex === dropIndex) return;

    const updatedOptions = [...dropdownInput.options];
    const [draggedItem] = updatedOptions.splice(draggedIndex, 1);
    updatedOptions.splice(dropIndex, 0, draggedItem);

    setDropdownInput((prev) => ({ ...prev, options: updatedOptions }));
  };

  return (
    <>
      <div  >
        <div className='d-flex flex-column w-100 h-100 p-4'>
          <div className='d-flex flex-row flex-wrap w-100 gap-2'>
            <CButton className='mb-4 d-flex gap-2' variant="outline" style={{ width: "max-content" }} onClick={handleAddOptions}>
              <Plus />
              <p className='p-0 m-0'>Add Option</p>
            </CButton>

            <CButton className='mb-4 d-flex gap-2' variant="outline" color='success' style={{ width: "max-content" }} onClick={handleAddQuestion}>
              <Plus />
              <p className='p-0 m-0'>Add Question</p>
            </CButton>
          </div>


          <div className='w-100 d-flex gap-2 mb-3'>

            <CFormCheck
              id='fillYesNoUnknown'
              checked={fillYesNo}
              onChange={(e) => handleFillYesNoUnknown(e.target.checked)}

            />
            <CFormLabel> Fill Yes/No/Unknown Options</CFormLabel>
          </div>

          <div className='d-flex flex-column gap-2'>
            {dropdownInput?.options?.length > 0 &&
              dropdownInput?.options.map((option, idx) => (
                <div
                  key={option.id ?? idx}
                  draggable
                  onDragStart={(e) => handleDragStart(e, idx)}
                  onDragOver={handleDragOver}
                  onDrop={(e) => handleDrop(e, idx)}
                  className='custom-form-builder-theme__option-row shadow-ex'
                  style={{ cursor: 'move' }}
                >
                  <Accordions
                    title={<p className='font-weight-medium mb-0' style={{ fontSize: '13px' }}>Name</p>}
                    headerContent={
                      <OptionNameField
                        value={option.label || ''}
                        onChange={(e) => handleChangeOption(e, idx)}
                      />
                    }
                    dropdownInput={dropdownInput}
                    setDropdownInput={setDropdownInput}
                    idx={idx}
                    linkQuestionCallback={linkQuestionCallback}
                    onConfigureOption={() => setConfigurationTarget({ id: option.id, option })}

                    content={
                      <div>
                        <div className='w-100'>
                          <p className='font-weight-medium mb-2 patient-theme-copy-label'>Provider Instruction</p>
                          <CFormTextarea
                            value={option.providerInstruction ?? ''}
                            onChange={(e) => {
                              const providerInstruction = e.target.value;
                              setDropdownInput((prev) => ({
                                ...prev,
                                options: prev.options.map((item, index) =>
                                  index === idx ? { ...item, providerInstruction } : item
                                ),
                              }));
                            }}
                            placeholder='Enter provider instruction here...'
                          />
                        </div>
                      </div>
                    }
                  />
                </div>
              ))}
          </div>

        </div>

        {configurationOption && (
          <OptionConfigurationModal
            key={configurationOption.id ?? 'option-configuration'}
            option={configurationOption}
            onClose={() => setConfigurationTarget(null)}
            editorContext={{ labList, medicationData, imagingData, diagnosiss, diagnosisForNested, addQuestions }}
            onSave={(childOptions, optionPatch = {}) => {
              setDropdownInput((prev) => ({
                ...prev,
                options: prev.options.map((option) => {
                  const isTarget = configurationTarget.id != null
                    ? option.id === configurationTarget.id
                    : option === configurationTarget.option;
                  return isTarget ? { ...option, ...optionPatch, options: childOptions } : option;
                }),
              }));
            }}
          />
        )}

        {isBuilderVisible && (
          <CModal size="xl" visible={isBuilderVisible}>
            <motion.div
              className={`w-100 top-0 left-0 position-fixed  d-flex align-items-center justify-content-center    ${isBuilderVisible ? 'visible' : "invisible"}}`}
              style={{ inset: 0, height: '100vh', background: "#00000061" }}
            >
              {!questionType &&
                <motion.div className='custom-form-builder-theme__type-picker shadow-lg' style={{ width: "40%", height: "40%", borderRadius: "40px" }}>

                  <div className='d-flex align-items-center justify-content-center flex-column w-100 h-100'>
                    <p className='font-weight-bold fs-5 mb-3'>Select Question Type</p>
                    <div className='d-flex align-items-center justify-content-center gap-3'>
                      {/* Text Input Card */}
                      <span
                        onClick={() => {
                          resetInputState();
                          // setQuestionType('input');
                        }}
                        style={{
                          width: "150px",
                          height: "150px",
                          borderRadius: "12px",
                          cursor: "pointer",
                          background: "#4c8bf5",
                          transition: "all 0.2s ease-in-out",
                          boxShadow: questionType === 'input' ? '0 6px 15px rgba(76, 139, 245, 0.4)' : '0 3px 10px rgba(0, 0, 0, 0.1)',
                          transform: questionType === 'input' ? 'scale(1.03)' : 'scale(1)',
                        }}
                        className={`d-flex text-white flex-column shadow justify-content-center align-items-center p-2 ${questionType === 'input' ? "border border-primary" : ""}`}
                      >
                        <Pencil className='fs-3' />
                        <p className='font-weight-semibold fs-6 p-0 m-0'>Freetype</p>
                      </span>

                      {/* Dropdown Card */}
                      <span
                        onClick={() => {
                          resetDropdownState();

                        }}
                        style={{
                          width: "150px",
                          height: "150px",
                          borderRadius: "12px",
                          cursor: "pointer",
                          background: "#4c8bf5",
                          transition: "all 0.2s ease-in-out",
                          boxShadow: questionType === 'dropdown' ? '0 6px 15px rgba(92, 184, 92, 0.4)' : '0 3px 10px rgba(0, 0, 0, 0.1)',
                          transform: questionType === 'dropdown' ? 'scale(1.03)' : 'scale(1)',
                        }}
                        className={`d-flex text-white flex-column shadow justify-content-center align-items-center p-2 ${questionType === 'dropdown' ? "border border-primary" : ""}`}
                      >
                        <span className='border border-white d-flex align-items-center justify-content-end rounded' style={{ width: "80px", height: "25px" }}>
                          <ChevronDown className='fs-5 align-middle' />
                        </span>
                        <p className='font-weight-semibold fs-6 p-0 m-0'>Options</p>
                      </span>
                    </div>
                    <CButton
                      color="secondary"
                      className="mt-3 px-4 ui-action-btn ui-action-btn--secondary"
                      onClick={() => setIsBuilderVisible(false)}
                    >
                      Close
                    </CButton>
                  </div>
                </motion.div>
              }


            </motion.div>


            {questionType === 'input' && (
              <div className='w-100 h-50'>
                <QuestionTextInputFormBuilder
                  saveMode="options"
                  selectedOption={selectedOption}
                  setIsOpenModal={handleBuilderClose}
                  mode="Add"
                  currentTextInputs={currentTextInputs}
                  dropdownInput={dropdownInput}
                  saveQuestion={handleSaveNewQuestion}
                  styling="show"
                  diagnosisForNested={diagnosiss}
                  setCurrentTextInputs={setCurrentTextInputs}
                  addQuestions={addQuestions}
                  setIsBuilderVisible={setIsBuilderVisible}
                  setQuestionType={setQuestionType}
                />
              </div>
            )}
            {questionType === 'dropdown' && (
              <QuestionDropdownBuilder
                saveMode="options"
                selectedOption={selectedOption}
                setIsOpenModal={handleBuilderClose}
                mode="Add"
                dropdownInput={dropdownInput}
                saveQuestion={handleSaveNewQuestion}
                styling="show"
                diagnosisForNested={diagnosiss}
                setIsBuilderVisible={setIsBuilderVisible}
                setQuestionType={setQuestionType}
              />
            )}
          </CModal>



        )}


        {addQuestionModal && (
          <CModal className="patient-theme-modal assessment-plan-suggestion-theme__modal" size="lg" visible={addQuestionModal} onClose={() => setAddQuestionModal(false)}>
            <CModalHeader className="text-warning">
              <CModalTitle>Select Options to Add a Question</CModalTitle>
            </CModalHeader>
            <CModalBody className="assessment-plan-suggestion-theme__modal-body">
              <div className="d-flex flex-column gap-2 mb-3">
                {dropdownInput.options.map((option, idx) => (
                  <div key={idx} className="d-flex align-items-center">
                    <CFormCheck
                      id={`option-${idx}`}
                      label={option.label || `Option ${idx + 1}`}
                      checked={selectedOptions.includes(idx)}
                      onChange={() => toggleOptionSelection(idx)}
                    />
                  </div>
                ))}
              </div>
              <div className="d-flex justify-content-end gap-2 mt-4">
                <CButton
                  color="primary"
                  className="ui-action-btn ui-action-btn--primary"
                  onClick={handleSelectedOption}
                >
                  Create Question
                </CButton>
                <CButton
                  color="secondary"
                  className="ui-action-btn ui-action-btn--secondary"
                  onClick={() => setAddQuestionModal(false)}
                >
                  Close
                </CButton>
              </div>
            </CModalBody>
          </CModal>
        )}
      </div >
    </>
  );
};

export default QuestionDropdownOptions;
